import ProductTypeLabel from 'LuxKit/Label/ProductTypeLabel'
import useCruiseOfferView from 'hooks/Cruise/useCruiseOfferView'
import { isCruiseOffer } from 'lib/offer/offerTypes'
import React, { useMemo } from 'react'
import BookmarkButton from 'tripPlanner/components/Bookmark/BookmarkButton'
import type { SearchTileLogo } from '../SearchTile'
import SearchTile from '../SearchTile'
import SearchTileRowOverlineJourney from '../shared/SearchTileRowOverlineJourney'
import CruiseSearchTileFeatures from './CruiseSearchTileFeatures'
import CruiseSearchTileLabels from './CruiseSearchTileLabels'
import CruiseSearchTileMeta from './CruiseSearchTileMeta'
import CruiseSearchTilePriceStack from './CruiseSearchTilePriceStack'
import TextButton from 'LuxKit/Button/TextButton'
import useCruiseSelectedCabinType from 'hooks/useCruiseSelectedCabinType'
import { useCurrentSiteTakeover } from 'takeovers/utils/hooks/useCurrentSiteTakeover'
import { trimCruiseShipNameFromTitle } from 'lib/cruises/cruiseUtils'

interface Props {
  offer: App.CruiseOffer | App.TourOffer | App.TourOfferSummary
  filters?: App.OfferListFilters
}

function CruiseOfferTile({ offer, filters }: Props) {
  const selectedCabinType = useCruiseSelectedCabinType(isCruiseOffer(offer) ? offer.cruiseType : undefined)
  const view = useCruiseOfferView({ offer, cabinTypes: selectedCabinType || undefined })

  const logo = useMemo((): SearchTileLogo => ({
    compact: { id: view.cruiseLineImage, title: view.cruiseLineName },
    full: { id: view.cruiseLineImage, title: view.cruiseLineName },
  }), [view])

  const title = useMemo(() => trimCruiseShipNameFromTitle(offer.name), [offer.name])

  const offerSiteTakeover = useCurrentSiteTakeover({ offer })

  return <SearchTile
    banner={<>{offerSiteTakeover?.searchPage?.tileBanner}</>}
    action={<TextButton nonInteractable kind="primary">View offer</TextButton>}
    bookmarkAction={<BookmarkButton offer={offer} />}
    features={<CruiseSearchTileFeatures view={view} filters={filters} />}
    images={offer.images}
    labels={<CruiseSearchTileLabels view={view} />}
    logo={logo}
    meta={<CruiseSearchTileMeta view={view} />}
    overline={<SearchTileRowOverlineJourney start={view.departureCity} end={view.destinationCity} />}
    pricePoint={<CruiseSearchTilePriceStack view={view} />}
    productLabel={<ProductTypeLabel productType={offer.productType} />}
    title={title}
    offer={offer}
  />
}

export default CruiseOfferTile
